import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver filed an inventory of the securement equipment on the unit.
 */
export const equipmentInventoryV1 = tmsEventKind(
  { category: "equipment", kind: "equipmentInventory", version: 1 },
  { refs: formSubmissionRefs, facts: {} },
);

export const EquipmentInventoryV1Schema = equipmentInventoryV1.schema;
export const EquipmentInventoryV1FactsSchema = equipmentInventoryV1.facts;

export type EquipmentInventoryV1 = z.infer<typeof EquipmentInventoryV1Schema>;
export type EquipmentInventoryV1Facts = z.infer<typeof EquipmentInventoryV1FactsSchema>;

/** Every version of `equipmentInventory`, keyed by version. What `catalog.ts` places under `equipment`. */
export const equipmentInventory = { 1: equipmentInventoryV1 } as const;
